import React, {Component} from "react";
import {Table} from "semantic-ui-react";
import moment from "moment";


export default class LoggingRow extends Component{
    constructor(props) {
        super(props)
    }
    render(){
        const {logging} = this.props
        let color = ''
        if (logging.success === true){
            color = ''
        }else {
            color = '#FC4B50'
        }
        const time = moment(logging.request_received_at).format('DD.MM.YYYY HH:mm')
        const duration = parseFloat(logging.request_duration).toFixed(2)
        return(
            <Table.Row style={{backgroundColor: color}}>
                <Table.Cell>{time}</Table.Cell>
                <Table.Cell>{logging.name}</Table.Cell>
                <Table.Cell>{logging.message}</Table.Cell>
                <Table.Cell>{duration}s</Table.Cell>
            </Table.Row>
        )
    }
}